"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paletteValueToRgbaString = void 0;
var _spectrumConfigs = require("../spectrum/spectrumConfigs");
var _memoize = require("../utils/memoize");
var _paletteValueToCacheName = require("./paletteValueToCacheName");
var _paletteValueToTuple2 = require("./paletteValueToTuple");
/**
 * `Please don't use this unless you absolutely have to. This is meant as last resort.`
 * Takes a palette value and returns the rgba string
 * @param paletteValue - gray0
 * @param spectrum  - light or dark
 * @returns rgba string - rgba(255,255,255,1)
 */
const paletteValueToRgbaString = (0, _memoize.memoize)((paletteValue, spectrum) => {
  const _paletteValueToTuple = (0, _paletteValueToTuple2.paletteValueToTuple)(paletteValue),
    alias = _paletteValueToTuple[0],
    opacity = _paletteValueToTuple[1];
  const spectrumConfig = _spectrumConfigs.spectrumConfigs.base[spectrum];
  const _spectrumConfig$alias = spectrumConfig[alias],
    red = _spectrumConfig$alias[0],
    green = _spectrumConfig$alias[1],
    blue = _spectrumConfig$alias[2];
  return `rgba(${red},${green},${blue},${opacity})`;
}, _paletteValueToCacheName.paletteValueToCacheName);
exports.paletteValueToRgbaString = paletteValueToRgbaString;